import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import is from '@sindresorhus/is';
import { useContext } from 'react';

import { route } from './route';
import { NoConsentDialog, TermsForm } from './TermsForm';
import { ApplicationContext } from '../../../../shared/source/context/context';
import { useConsentQuery } from '../../../../shared/source/query-hooks/consent';
import { route as onboardingRoutes } from '../pages/onboarding/constants';

import type { FunctionComponent } from 'react';

const disableConsentDialogRoutes = [onboardingRoutes.patterns.onboarding];

export const ConsentDialog: FunctionComponent = () => {
    const { applicationState, translate } = useContext(ApplicationContext);
    const consentQuery = useConsentQuery();
    const declinedConsent = applicationState.locationSearchParams.get(route.searchParams.decline) === 'true';
    const { pathname } = applicationState.location;

    if (disableConsentDialogRoutes.includes(pathname)) {
        return null;
    }

    if (declinedConsent) {
        return <NoConsentDialog />;
    }

    if (is.undefined(consentQuery.data?.status) || consentQuery.data.status === 'yes') {
        return null;
    }

    return (
        <Dialog aria-label="Terms consent dialog" open={true}>
            <DialogTitle variant="h4">{translate('dialogs.terms.title')}</DialogTitle>
            <TermsForm consentStatus={consentQuery.data.status} />
        </Dialog>
    );
};
